// extracted by mini-css-extract-plugin
export var base = "_3j-0";
export var updateBanner = "_3j-1";